import OldWoman from '../assets/old-woman.svg'
import Baby from '../assets/baby.svg'
import Money from '../assets/money.svg'
import DerelictHouse from '../assets/derelict-house.svg'
import ZHFlag from '../assets/zh-flag.svg'
import BEFlag from '../assets/be-flag.svg'
import VDFlag from '../assets/vd-flag.svg'
import italyFlag from '../assets/italy-flag.svg'
import germanyFlag from '../assets/germany-flag.svg'
import portugalFlag from '../assets/portugal-flag.svg'
import ring from '../assets/ring.svg'
import church from '../assets/church.svg'
import mosque from '../assets/mosque.svg'
import synagogue from '../assets/synagogue.svg'
import ballotBox from '../assets/ballot-box.svg'
import womanLiftingWeights from '../assets/woman-lifting-weights.svg'
import personRunning from '../assets/person-running.svg'
import salad from '../assets/salad.svg'
import beer from '../assets/beer.svg'
import wineGlass from '../assets/wine-glass.svg'
import cocktail from '../assets/cocktail.svg'
import pill from '../assets/pill.svg'
import dog from '../assets/dog.svg'
import necktie from '../assets/necktie.svg'
import car from '../assets/car.svg'
import train from '../assets/train.svg'
import bicycle from '../assets/bicycle.svg'
import clock from '../assets/clock.svg'
import student from '../assets/student.svg'
import house from '../assets/house.svg'
import swipe from '../assets/swipe.svg'

export default {
  de: [
    {
      title: '',
      categories: [
        {
          title:
            '<div class="introText">Stellen wir uns vor, dass in der Schweiz nur 100 Menschen leben. Wie würde dieses Dorf aussehen?</div><div class="hint"><div class="path"></div><div class="hand-icon"></div></div>',
          value: 100,
        },
      ],
      svgPositionsDimensions: { width: 170, height: 114 },
      svgPositions: [
        { cx: 37.29198, cy: 78.23775 },
        { cx: 47.98494, cy: 78.23775 },
        { cx: 58.63296, cy: 78.23775 },
        { cx: 69.29405, cy: 78.23775 },
        { cx: 79.94861, cy: 78.25756 },
        { cx: 90.59584, cy: 78.25756 },
        { cx: 101.25773, cy: 78.25756 },
        { cx: 111.91859, cy: 78.23775 },
        { cx: 122.55872, cy: 78.23775 },
        { cx: 133.18781, cy: 78.23775 },
        { cx: 37.29198, cy: 67.78843 },
        { cx: 47.98494, cy: 67.78843 },
        { cx: 58.63296, cy: 67.78843 },
        { cx: 69.29405, cy: 67.78843 },
        { cx: 79.94861, cy: 67.82805 },
        { cx: 90.59584, cy: 67.82805 },
        { cx: 101.25773, cy: 67.82805 },
        { cx: 111.91859, cy: 67.78843 },
        { cx: 122.55872, cy: 67.78843 },
        { cx: 133.18781, cy: 67.78843 },
        { cx: 37.29198, cy: 57.3391 },
        { cx: 47.98494, cy: 57.3391 },
        { cx: 58.63296, cy: 57.3391 },
        { cx: 69.29405, cy: 57.3391 },
        { cx: 79.94861, cy: 57.39854 },
        { cx: 90.59584, cy: 57.39854 },
        { cx: 101.25773, cy: 57.39854 },
        { cx: 111.91859, cy: 57.3391 },
        { cx: 122.55872, cy: 57.3391 },
        { cx: 133.18781, cy: 57.3391 },
        { cx: 37.29198, cy: 46.88978 },
        { cx: 47.98494, cy: 46.88978 },
        { cx: 58.63296, cy: 46.88978 },
        { cx: 69.29405, cy: 46.88978 },
        { cx: 79.94861, cy: 46.96903 },
        { cx: 90.59584, cy: 46.96903 },
        { cx: 101.25773, cy: 46.96903 },
        { cx: 111.91859, cy: 46.88978 },
        { cx: 122.55872, cy: 46.88978 },
        { cx: 133.18781, cy: 46.88978 },
        { cx: 154.22953, cy: 88.68707 },
        { cx: 47.98494, cy: 36.44046 },
        { cx: 58.63296, cy: 36.44046 },
        { cx: 69.29405, cy: 36.44046 },
        { cx: 79.94861, cy: 36.53952 },
        { cx: 90.59584, cy: 36.53952 },
        { cx: 101.25773, cy: 36.53952 },
        { cx: 111.91859, cy: 36.44046 },
        { cx: 122.55872, cy: 36.44046 },
        { cx: 133.18781, cy: 36.44046 },
        { cx: 5, cy: 88.68707 },
        { cx: 47.98494, cy: 25.99114 },
        { cx: 58.63296, cy: 25.99114 },
        { cx: 69.29405, cy: 25.99114 },
        { cx: 79.94861, cy: 25.99114 },
        { cx: 90.59584, cy: 25.99114 },
        { cx: 101.25773, cy: 25.99114 },
        { cx: 111.91859, cy: 25.99114 },
        { cx: 122.55872, cy: 25.99114 },
        { cx: 133.18781, cy: 25.99114 },
        { cx: 143.75298, cy: 46.88978 },
        { cx: 143.75298, cy: 57.3391 },
        { cx: 154.22953, cy: 78.23775 },
        { cx: 69.29405, cy: 15.54182 },
        { cx: 79.94861, cy: 15.54182 },
        { cx: 90.59584, cy: 15.54182 },
        { cx: 101.25773, cy: 15.54182 },
        { cx: 111.91859, cy: 15.54182 },
        { cx: 122.55872, cy: 15.54182 },
        { cx: 101.25773, cy: 5 },
        { cx: 15.86237, cy: 67.78843 },
        { cx: 47.98494, cy: 88.68707 },
        { cx: 58.63296, cy: 88.68707 },
        { cx: 69.29405, cy: 88.68707 },
        { cx: 79.94861, cy: 88.68707 },
        { cx: 90.59584, cy: 88.68707 },
        { cx: 101.25773, cy: 88.68707 },
        { cx: 111.91859, cy: 88.68707 },
        { cx: 122.55872, cy: 88.68707 },
        { cx: 154.22953, cy: 57.3391 },
        { cx: 26.51532, cy: 46.88978 },
        { cx: 47.98494, cy: 99.13639 },
        { cx: 58.63296, cy: 99.13639 },
        { cx: 69.29405, cy: 99.13639 },
        { cx: 79.94861, cy: 99.13639 },
        { cx: 26.51532, cy: 78.23775 },
        { cx: 111.91859, cy: 109.58571 },
        { cx: 111.91859, cy: 99.13639 },
        { cx: 164.8512, cy: 46.88978 },
        { cx: 15.86237, cy: 88.68707 },
        { cx: 26.51532, cy: 57.3391 },
        { cx: 26.51532, cy: 67.78843 },
        { cx: 15.86237, cy: 78.23775 },
        { cx: 143.75298, cy: 67.78843 },
        { cx: 164.8512, cy: 67.78843 },
        { cx: 47.98494, cy: 109.58571 },
        { cx: 37.29198, cy: 88.68707 },
        { cx: 154.22953, cy: 67.78843 },
        { cx: 164.8512, cy: 57.3391 },
        { cx: 143.75298, cy: 78.23775 },
      ],
    },
    {
      title: (
        <span>
          <span>Alter&nbsp;</span>
          <img src={Baby} className='icon' alt='Icon Baby' key='Baby' />
          &nbsp;
          <img
            src={OldWoman}
            className='icon'
            alt='Icon alte Frau'
            key='OldWoman'
          />
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: '0–9&nbsp;Jahre', value: 10 },
        { title: '10–19&nbsp;Jahre', value: 10 },
        { title: '20–39&nbsp;Jahre', value: 26 },
        { title: '40–64&nbsp;Jahre', value: 35 },
        { title: '65–79&nbsp;Jahre', value: 14 },
        { title: '80+', value: 5 },
      ],
    },
    {
      title: (
        <span>
          <span>
            Steuerpflichtiges Vermögen&nbsp;
            <img
              src={Money}
              className='icon money'
              alt='Icon Geldsack'
              key='money'
            />
          </span>
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Kein Vermögen', value: 15 },
        { title: "0–50'000&nbsp;Fr.", value: 20 },
        { title: "50'000–100'000&nbsp;Fr.", value: 6 },
        { title: "100'000–1 Mio.&nbsp;Fr.", value: 19 },
        { title: '1–3&nbsp;Mio.&nbsp;Fr.', value: 3 },
        { title: '> 3&nbsp;Mio.&nbsp;Fr.', value: 1 },
        { title: 'Nicht steuerpflichtig', value: 36 },
      ],
    },
    {
      title: (
        <>
          <span>
            <span>Armut&nbsp; </span>

            <img
              src={DerelictHouse}
              className='icon'
              alt='Icon kaputtes Haus'
              key='DerelictHouse'
            />
          </span>
          <span className='secondLine'>
            (&lt;2279&nbsp;Fr. pro&nbsp;Mt. pro&nbsp;Pers.)
          </span>
        </>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Arm', value: 9 },
        { title: 'Nicht arm', value: 91 },
      ],
    },
    {
      title: (
        <span>
          <span>Kantone&nbsp;</span>
          <img
            src={ZHFlag}
            className='icon canton'
            alt='Icon Wappen Kanton Zürich'
            key='ZHFlag'
          />
          &nbsp;
          <img
            src={BEFlag}
            className='icon canton'
            alt='Icon Wappen Kanton Bern'
            key='BEFlag'
          />
          &nbsp;
          <img
            src={VDFlag}
            className='icon canton'
            alt='Icon Wappen Kanton Waadt'
            key='VDFlag'
          />
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Zürich', value: 18 },
        { title: 'Bern', value: 12 },
        { title: 'Waadt', value: 9 },
        { title: 'Aargau', value: 8 },
        { title: 'St. Gallen', value: 6 },
        { title: 'Genf', value: 6 },
        { title: 'Luzern', value: 5 },
        { title: 'Wallis', value: 4 },
        { title: 'Tessin', value: 4 },
        { title: 'Restl. Kantone', value: 28 },
      ],
    },
    {
      title: (
        <span>
          <span>Nationalität&nbsp;</span>
          <img
            src={italyFlag}
            className='icon'
            alt='Icon Italien Flagge'
            key='italyFlag'
          />
          &nbsp;
          <img
            src={germanyFlag}
            className='icon'
            alt='Icon Deutschland Flagge'
            key='germanyFlag'
          />
          &nbsp;
          <img
            src={portugalFlag}
            className='icon'
            alt='Icon Portugal Flagge'
            key='portugalFlag'
          />
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Schweiz', value: 74 },
        { title: 'Italien', value: 4 },
        { title: 'Deutschland', value: 4 },
        { title: 'Portugal', value: 3 },
        { title: 'Frankreich', value: 2 },
        { title: 'Kosovo', value: 1 },
        { title: 'Spanien', value: 1 },
        { title: 'Türkei', value: 1 },
        { title: 'Übriges Europa', value: 6 },
        { title: 'Asien, Ozeanien, Staatenlos', value: 2 },
        { title: 'Afrika', value: 1 },
        { title: 'Amerika', value: 1 },
      ],
    },
    {
      title: (
        <span>
          <span>Zivilstand&nbsp;</span>

          <img src={ring} className='icon' alt='Icon Fingerring' key='ring' />
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        {
          title: 'Ledig<br><span class="grayedOut">(Unter 18&nbsp;J.)</span>',
          value: 45,
          grayedOut: 18,
        },
        { title: 'Verheiratet', value: 41 },
        { title: 'Geschieden', value: 9 },
        { title: 'Verwitwet', value: 5 },
      ],
    },
    {
      title: (
        <span>
          <span>Konfession&nbsp;</span>
          <img
            src={church}
            className='icon religion'
            alt='Icon Kirche'
            key='church'
          />
          &nbsp;
          <img
            src={mosque}
            className='icon religion'
            alt='Icon Moschee'
            key='mosque'
          />
          &nbsp;
          <img
            src={synagogue}
            className='icon religion synagogue'
            alt='Icon Synagoge'
            key='synagogue'
          />
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Römisch-katholisch', value: 28 },
        { title: 'Konfessionslos', value: 27 },
        { title: 'Evangelisch-reformiert', value: 18 },
        { title: 'Muslimisch', value: 5 },
        { title: 'Andere Christen', value: 5 },
        { title: 'Andere', value: 1 },
        { title: 'Unbekannt', value: 1 },
        {
          title:
            '<span class="grayedOut">Nicht berücksichtigt (Unter 15&nbsp;J.)</span>',
          value: 15,
          grayedOut: 15,
        },
      ],
    },
    {
      title: (
        <span>
          <span>
            Wahlverhalten&nbsp;2019&nbsp;
            <img
              src={ballotBox}
              className='icon ballotBox'
              alt='Icon Wahlurne'
              key='ballotBox'
            />
          </span>
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Nicht wahlberechtigt', value: 37 },
        { title: 'Nichtwähler', value: 35 },
        { title: 'SVP', value: 7 },
        { title: 'SP', value: 5 },
        { title: 'FDP', value: 4 },
        { title: 'GPS', value: 4 },
        { title: 'CVP (Mitte)', value: 3 },
        { title: 'GLP', value: 2 },
        { title: 'Andere', value: 3 },
      ],
    },
    {
      title: (
        <span>
          <span>Körpergewicht&nbsp;</span>

          <img
            src={womanLiftingWeights}
            className='icon weights'
            alt='Icon Gewichtheben'
            key='womanLiftingWeights'
          />
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Untergewicht<br/>(BMI&nbsp;<&nbsp;18,5)', value: 3 },
        {
          title: 'Normalgewicht<br/>(18,5&nbsp;<=&nbsp;BMI&nbsp;<&nbsp;25)',
          value: 46,
        },
        {
          title: 'Übergewicht<br/>(25&nbsp;<=&nbsp;BMI&nbsp;<&nbsp;30)',
          value: 26,
        },
        { title: 'Adipositas<br/>(BMI&nbsp;>=&nbsp;30)', value: 10 },
        {
          title:
            '<span class="grayedOut">Nicht berücksichtigt (Unter 15&nbsp;J.)</span>',
          value: 15,
          grayedOut: 15,
        },
      ],
    },
    {
      title: (
        <span>
          <span>
            Sportliche Aktivität&nbsp;
            <img
              src={personRunning}
              className='icon'
              alt='Icon laufende Person'
              key='personRunning'
            />
          </span>
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Aktiv<br/>(>3h pro&nbsp;Woche)', value: 31 },
        { title: 'Teilaktiv<br/>(<3h pro&nbsp;Woche)', value: 24 },
        { title: 'Inaktiv', value: 30 },
        {
          title:
            '<span class="grayedOut">Nicht berücksichtigt (Unter 15&nbsp;J.)</span>',
          value: 15,
          grayedOut: 15,
        },
      ],
    },
    {
      title: (
        <span>
          <span>Ernährung&nbsp;</span>

          <img
            src={salad}
            className='icon salad'
            alt='Icon Salat'
            key='salad'
          />
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Vegan/vegetarisch', value: 4 },
        { title: 'Mit Fleisch', value: 82 },
        {
          title:
            '<span class="grayedOut">Nicht berücksichtigt (Unter 14&nbsp;J.)</span>',
          value: 14,
          grayedOut: 14,
        },
      ],
    },
    {
      title: (
        <span>
          <span>
            Alkoholkonsum&nbsp;
            <b>
              <img
                src={beer}
                className='icon beer'
                alt='Icon Bierkrug'
                key='beer'
              />
              &nbsp;
              <img
                src={wineGlass}
                className='icon wineGlass'
                alt='Icon Weinglas'
                key='wineGlass'
              />
              &nbsp;
              <img
                src={cocktail}
                className='icon cocktail'
                alt='Icon Cocktailglas'
                key='cocktail'
              />
            </b>
          </span>
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Jeden Tag', value: 9 },
        { title: '3–6&nbsp;Mal pro&nbsp;W.', value: 12 },
        { title: '1–2&nbsp;Mal pro&nbsp;W.', value: 29 },
        { title: '<&nbsp;als 1&nbsp;Mal pro&nbsp;W.', value: 20 },
        { title: 'Nie, abstinent', value: 15 },
        {
          title:
            '<span class="grayedOut">Nicht berücksichtigt (Unter 15&nbsp;J.)</span>',
          value: 15,
          grayedOut: 15,
        },
      ],
    },
    {
      title: (
        <span>
          <span>
            Medikamenten&shy;konsum&nbsp;
            <img src={pill} className='icon' alt='Icon Pille' key='pill' />
          </span>
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Wöchentlich mind. 1&nbsp;Medikament', value: 43 },
        { title: 'Wöchentlich <1&nbsp;Medikament', value: 42 },
        {
          title:
            '<span class="grayedOut">Nicht berücksichtigt (Unter 15&nbsp;J.)</span>',
          value: 15,
          grayedOut: 15,
        },
      ],
    },
    {
      title: (
        <span>
          <span>
            Haustiere&nbsp;
            <img src={dog} className='icon dog' alt='Icon Hund' key='dog' />
          </span>
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Mit Haustier', value: 41 },
        { title: 'Ohne Haustier', value: 59 },
      ],
    },
    {
      title: (
        <span>
          <span>
            Mieter oder Eigentümer&nbsp;
            <img
              src={house}
              className='icon house'
              alt='Icon Haus mit Garten'
              key='house'
            />
          </span>
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Mieter', value: 61 },
        { title: 'Eigentümer', value: 36 },
        { title: 'Andere Situation', value: 3 },
      ],
    },
    {
      title: (
        <span>
          <span>
            Höchste abgeschlossene Ausbildung{' '}
            <img
              src={student}
              className='icon student'
              alt='Icon Student'
              key='student'
            />
          </span>
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Obligatorische Schule', value: 13 },
        { title: 'Berufslehre', value: 23 },
        { title: 'Gymnasium und Fachmittelschule', value: 7 },
        { title: 'Höhere Berufsbildung', value: 13 },
        { title: 'Hochschulen (Inkl.&nbsp;Universitäten)', value: 17 },
        {
          title:
            '<span class="grayedOut">Nicht berücksichtigt (Unter 25&nbsp;J.)</span>',
          value: 27,
          grayedOut: 27,
        },
      ],
    },
    {
      title: (
        <span>
          <span>
            Arbeitssituation&nbsp;
            <img
              src={necktie}
              className='icon necktie'
              alt='Icon Hemd und Krawatte'
              key='necktie'
            />
          </span>
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Arbeitnehmende', value: 48 },
        { title: 'Rentner/Rentnerinnen', value: 19 },
        { title: 'Selbstständig-erwerbende', value: 7 },
        { title: 'Ohne Erwerb<br/>(In Ausbildung etc.)', value: 6 },
        { title: 'Arbeitslos', value: 3 },
        { title: 'Hausfrauen/-männer', value: 2 },
        {
          title:
            '<span class="grayedOut">Nicht berücksichtigt (Unter 15&nbsp;J.)</span>',
          value: 15,
          grayedOut: 15,
        },
      ],
    },
    {
      title: (
        <span>
          <span>
            Pendelverhalten&nbsp;
            <b>
              <img src={car} className='icon car' alt='Icon Auto' key='car' />
              &nbsp;
              <img
                src={train}
                className='icon train'
                alt='Icon Zug'
                key='train'
              />
              &nbsp;
              <img
                src={bicycle}
                className='icon bicycle'
                alt='Icon Fahrrad'
                key='bicycle'
              />
            </b>
          </span>
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Auto', value: 24 },
        { title: 'Öffentlicher Verkehr', value: 13 },
        { title: 'Velo/E-Bike', value: 4 },
        { title: 'Zu Fuss', value: 4 },
        { title: 'Motorrad', value: 1 },
        {
          title: 'Nichtpendler<br />(Homeoffice, ohne Erwerb etc.)',
          value: 54,
        },
      ],
    },
    {
      title: (
        <span>
          <span>
            Pendelzeit&nbsp;
            <img
              src={clock}
              className='icon clock'
              alt='Icon Stoppuhr'
              key='clock'
            />
          </span>
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: '0–15&nbsp;Min.', value: 16 },
        { title: '16–30&nbsp;Min.', value: 15 },
        { title: '31–45&nbsp;Min.', value: 7 },
        { title: '46–60&nbsp;Min.', value: 4 },
        { title: '>60&nbsp;Min.', value: 4 },
        {
          title: 'Nichtpendler<br />(Homeoffice, ohne Erwerb etc.)',
          value: 54,
        },
      ],
    },
  ],
  fr: [
    {
      title: '',
      categories: [
        {
          title:
            '<div class="introText">Imaginons que la Suisse ne compte que 100 habitants et habitantes. A&nbsp;quoi ressemblerait ce village?</div><div class="hint"><div class="path"></div><div class="hand-icon"></div></div>',
          value: 100,
        },
      ],
      svgPositionsDimensions: { width: 170, height: 114 },
      svgPositions: [
        { cx: 37.29198, cy: 78.23775 },
        { cx: 47.98494, cy: 78.23775 },
        { cx: 58.63296, cy: 78.23775 },
        { cx: 69.29405, cy: 78.23775 },
        { cx: 79.94861, cy: 78.25756 },
        { cx: 90.59584, cy: 78.25756 },
        { cx: 101.25773, cy: 78.25756 },
        { cx: 111.91859, cy: 78.23775 },
        { cx: 122.55872, cy: 78.23775 },
        { cx: 133.18781, cy: 78.23775 },
        { cx: 37.29198, cy: 67.78843 },
        { cx: 47.98494, cy: 67.78843 },
        { cx: 58.63296, cy: 67.78843 },
        { cx: 69.29405, cy: 67.78843 },
        { cx: 79.94861, cy: 67.82805 },
        { cx: 90.59584, cy: 67.82805 },
        { cx: 101.25773, cy: 67.82805 },
        { cx: 111.91859, cy: 67.78843 },
        { cx: 122.55872, cy: 67.78843 },
        { cx: 133.18781, cy: 67.78843 },
        { cx: 37.29198, cy: 57.3391 },
        { cx: 47.98494, cy: 57.3391 },
        { cx: 58.63296, cy: 57.3391 },
        { cx: 69.29405, cy: 57.3391 },
        { cx: 79.94861, cy: 57.39854 },
        { cx: 90.59584, cy: 57.39854 },
        { cx: 101.25773, cy: 57.39854 },
        { cx: 111.91859, cy: 57.3391 },
        { cx: 122.55872, cy: 57.3391 },
        { cx: 133.18781, cy: 57.3391 },
        { cx: 37.29198, cy: 46.88978 },
        { cx: 47.98494, cy: 46.88978 },
        { cx: 58.63296, cy: 46.88978 },
        { cx: 69.29405, cy: 46.88978 },
        { cx: 79.94861, cy: 46.96903 },
        { cx: 90.59584, cy: 46.96903 },
        { cx: 101.25773, cy: 46.96903 },
        { cx: 111.91859, cy: 46.88978 },
        { cx: 122.55872, cy: 46.88978 },
        { cx: 133.18781, cy: 46.88978 },
        { cx: 154.22953, cy: 88.68707 },
        { cx: 47.98494, cy: 36.44046 },
        { cx: 58.63296, cy: 36.44046 },
        { cx: 69.29405, cy: 36.44046 },
        { cx: 79.94861, cy: 36.53952 },
        { cx: 90.59584, cy: 36.53952 },
        { cx: 101.25773, cy: 36.53952 },
        { cx: 111.91859, cy: 36.44046 },
        { cx: 122.55872, cy: 36.44046 },
        { cx: 133.18781, cy: 36.44046 },
        { cx: 5, cy: 88.68707 },
        { cx: 47.98494, cy: 25.99114 },
        { cx: 58.63296, cy: 25.99114 },
        { cx: 69.29405, cy: 25.99114 },
        { cx: 79.94861, cy: 25.99114 },
        { cx: 90.59584, cy: 25.99114 },
        { cx: 101.25773, cy: 25.99114 },
        { cx: 111.91859, cy: 25.99114 },
        { cx: 122.55872, cy: 25.99114 },
        { cx: 133.18781, cy: 25.99114 },
        { cx: 143.75298, cy: 46.88978 },
        { cx: 143.75298, cy: 57.3391 },
        { cx: 154.22953, cy: 78.23775 },
        { cx: 69.29405, cy: 15.54182 },
        { cx: 79.94861, cy: 15.54182 },
        { cx: 90.59584, cy: 15.54182 },
        { cx: 101.25773, cy: 15.54182 },
        { cx: 111.91859, cy: 15.54182 },
        { cx: 122.55872, cy: 15.54182 },
        { cx: 101.25773, cy: 5 },
        { cx: 15.86237, cy: 67.78843 },
        { cx: 47.98494, cy: 88.68707 },
        { cx: 58.63296, cy: 88.68707 },
        { cx: 69.29405, cy: 88.68707 },
        { cx: 79.94861, cy: 88.68707 },
        { cx: 90.59584, cy: 88.68707 },
        { cx: 101.25773, cy: 88.68707 },
        { cx: 111.91859, cy: 88.68707 },
        { cx: 122.55872, cy: 88.68707 },
        { cx: 154.22953, cy: 57.3391 },
        { cx: 26.51532, cy: 46.88978 },
        { cx: 47.98494, cy: 99.13639 },
        { cx: 58.63296, cy: 99.13639 },
        { cx: 69.29405, cy: 99.13639 },
        { cx: 79.94861, cy: 99.13639 },
        { cx: 26.51532, cy: 78.23775 },
        { cx: 111.91859, cy: 109.58571 },
        { cx: 111.91859, cy: 99.13639 },
        { cx: 164.8512, cy: 46.88978 },
        { cx: 15.86237, cy: 88.68707 },
        { cx: 26.51532, cy: 57.3391 },
        { cx: 26.51532, cy: 67.78843 },
        { cx: 15.86237, cy: 78.23775 },
        { cx: 143.75298, cy: 67.78843 },
        { cx: 164.8512, cy: 67.78843 },
        { cx: 47.98494, cy: 109.58571 },
        { cx: 37.29198, cy: 88.68707 },
        { cx: 154.22953, cy: 67.78843 },
        { cx: 164.8512, cy: 57.3391 },
        { cx: 143.75298, cy: 78.23775 },
      ],
    },
    {
      title: (
        <span>
          <span>Âge&nbsp;</span>
          <img src={Baby} className='icon' alt='Icon Baby' key='Baby' />
          &nbsp;
          <img
            src={OldWoman}
            className='icon'
            alt='Icon alte Frau'
            key='OldWoman'
          />
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: '0–9&nbsp;ans', value: 10 },
        { title: '10–19&nbsp;ans', value: 10 },
        { title: '20–39&nbsp;ans', value: 26 },
        { title: '40–64&nbsp;ans', value: 35 },
        { title: '65–79&nbsp;ans', value: 14 },
        { title: '80+', value: 5 },
      ],
    },
    {
      title: (
        <span>
          <span>
            Fortune imposable&nbsp;
            <img
              src={Money}
              className='icon money'
              alt='Icon Geldsack'
              key='money'
            />
          </span>
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Pas de patrimoine', value: 15 },
        { title: "0–50'000&nbsp;fr.", value: 20 },
        { title: "50'000–100'000&nbsp;fr.", value: 6 },
        { title: "100'000–1 Mio.&nbsp;fr.", value: 19 },
        { title: '1–3&nbsp;Mio.&nbsp;fr.', value: 3 },
        { title: '> 3&nbsp;Mio.&nbsp;fr.', value: 1 },
        { title: "Non soumis à l'impôt", value: 36 },
      ],
    },
    {
      title: (
        <>
          <span>
            <span>Pauvreté&nbsp; </span>

            <img
              src={DerelictHouse}
              className='icon'
              alt='Icon kaputtes Haus'
              key='DerelictHouse'
            />
          </span>
          <span className='secondLine'>
            (&lt;2279&nbsp;fr./mois par personne)
          </span>
        </>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Pauvres', value: 9 },
        { title: 'Pas pauvres', value: 91 },
      ],
    },
    {
      title: (
        <span>
          <span>Cantons&nbsp;</span>
          <img
            src={ZHFlag}
            className='icon canton'
            alt='Icon Wappen Kanton Zürich'
            key='ZHFlag'
          />
          &nbsp;
          <img
            src={BEFlag}
            className='icon canton'
            alt='Icon Wappen Kanton Bern'
            key='BEFlag'
          />
          &nbsp;
          <img
            src={VDFlag}
            className='icon canton'
            alt='Icon Wappen Kanton Waadt'
            key='VDFlag'
          />
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Zurich', value: 18 },
        { title: 'Berne', value: 12 },
        { title: 'Vaud', value: 9 },
        { title: 'Argovie', value: 8 },
        { title: 'Saint-Gall', value: 6 },
        { title: 'Genève', value: 6 },
        { title: 'Lucerne', value: 5 },
        { title: 'Valais', value: 4 },
        { title: 'Tessin', value: 4 },
        { title: 'Autres cantons', value: 28 },
      ],
    },
    {
      title: (
        <span>
          <span>Nationalités&nbsp;</span>
          <img
            src={italyFlag}
            className='icon'
            alt='Icon Italien Flagge'
            key='italyFlag'
          />
          &nbsp;
          <img
            src={germanyFlag}
            className='icon'
            alt='Icon Deutschland Flagge'
            key='germanyFlag'
          />
          &nbsp;
          <img
            src={portugalFlag}
            className='icon'
            alt='Icon Portugal Flagge'
            key='portugalFlag'
          />
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Suisse', value: 74 },
        { title: 'Italie', value: 4 },
        { title: 'Allemagne', value: 4 },
        { title: 'Portugal', value: 3 },
        { title: 'France', value: 2 },
        { title: 'Kosovo', value: 1 },
        { title: 'Espagne', value: 1 },
        { title: 'Turquie', value: 1 },
        { title: "Reste de l'Europe", value: 6 },
        { title: 'Asie, Océanie,<br>Apatride', value: 2 },
        { title: 'Afrique', value: 1 },
        { title: 'Amérique', value: 1 },
      ],
    },
    {
      title: (
        <span>
          <span>État civil&nbsp;</span>

          <img src={ring} className='icon' alt='Icon Fingerring' key='ring' />
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        {
          title:
            'Célibataires<br><span class="grayedOut">(Moins de 18&nbsp;ans)</span>',
          value: 45,
          grayedOut: 18,
        },
        { title: 'Marié·e·s', value: 41 },
        { title: 'Divorcé·e·s', value: 9 },
        { title: 'Veufs/Veuves', value: 5 },
      ],
    },
    {
      title: (
        <span>
          <span>Confession&nbsp;</span>
          <img
            src={church}
            className='icon religion'
            alt='Icon Kirche'
            key='church'
          />
          &nbsp;
          <img
            src={mosque}
            className='icon religion'
            alt='Icon Moschee'
            key='mosque'
          />
          &nbsp;
          <img
            src={synagogue}
            className='icon religion synagogue'
            alt='Icon Synagoge'
            key='synagogue'
          />
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Église catholique romaine', value: 28 },
        { title: 'Sans confession', value: 27 },
        { title: 'Église évangélique réformée', value: 18 },
        { title: 'Islam', value: 5 },
        { title: 'Autres religions chrétiennes', value: 5 },
        { title: 'Autres', value: 1 },
        { title: 'Inconnu', value: 1 },
        {
          title:
            '<span class="grayedOut">Pas pris en compte (Moins de 15&nbsp;ans)</span>',
          value: 15,
          grayedOut: 15,
        },
      ],
    },
    {
      title: (
        <span>
          <span>
            Comportement électoral&nbsp;2019&nbsp;
            <img
              src={ballotBox}
              className='icon ballotBox'
              alt='Icon Wahlurne'
              key='ballotBox'
            />
          </span>
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Pas de droit<br>de vote', value: 37 },
        { title: 'Ne votent pas', value: 35 },
        { title: 'UDC', value: 7 },
        { title: 'PS', value: 5 },
        { title: 'PLR', value: 4 },
        { title: 'PVS', value: 4 },
        { title: 'PDC (Centre)', value: 3 },
        { title: 'PVL', value: 2 },
        { title: 'Autres', value: 3 },
      ],
    },
    {
      title: (
        <span>
          <span>Masse corporelle&nbsp;</span>

          <img
            src={womanLiftingWeights}
            className='icon weights'
            alt='Icon Gewichtheben'
            key='womanLiftingWeights'
          />
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        {
          title: 'Insuffisance pondérale<br/>(IMC&nbsp;<&nbsp;18,5)',
          value: 3,
        },
        {
          title: 'Poids normal<br/>(18,5&nbsp;<=&nbsp;IMC&nbsp;<&nbsp;25)',
          value: 46,
        },
        {
          title: 'Surpoids<br/>(25&nbsp;<=&nbsp;IMC&nbsp;<&nbsp;30)',
          value: 26,
        },
        { title: 'Obésité<br/>(IMC&nbsp;>=&nbsp;30)', value: 10 },
        {
          title:
            '<span class="grayedOut">Pas pris en compte (Moins de 15&nbsp;ans)</span>',
          value: 15,
          grayedOut: 15,
        },
      ],
    },
    {
      title: (
        <span>
          <span>
            Activité physique&nbsp;
            <img
              src={personRunning}
              className='icon'
              alt='Icon laufende Person'
              key='personRunning'
            />
          </span>
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Actif<br/>(>3h par&nbsp;semaine)', value: 31 },
        { title: 'Partiellement actif<br/>(<3h par&nbsp;semaine)', value: 24 },
        { title: 'Inactif', value: 30 },
        {
          title:
            '<span class="grayedOut">Pas pris en compte (Moins de 15&nbsp;ans)</span>',
          value: 15,
          grayedOut: 15,
        },
      ],
    },
    {
      title: (
        <span>
          <span>Alimentation&nbsp;</span>
          <img
            src={salad}
            className='icon salad'
            alt='Icon Salat'
            key='salad'
          />
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Végétalien/végétarien', value: 4 },
        { title: 'Avec viande', value: 82 },
        {
          title:
            '<span class="grayedOut">Pas pris en compte (Moins de 14&nbsp;ans)</span>',
          value: 14,
          grayedOut: 14,
        },
      ],
    },
    {
      title: (
        <span>
          <span>
            Consommation d'alcool&nbsp;
            <b>
              <img
                src={beer}
                className='icon beer'
                alt='Icon Bierkrug'
                key='beer'
              />
              &nbsp;
              <img
                src={wineGlass}
                className='icon wineGlass'
                alt='Icon Weinglas'
                key='wineGlass'
              />
              &nbsp;
              <img
                src={cocktail}
                className='icon cocktail'
                alt='Icon Cocktailglas'
                key='cocktail'
              />
            </b>
          </span>
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Tous les jours', value: 9 },
        { title: '3–6&nbsp;fois/semaine', value: 12 },
        { title: '1–2&nbsp;fois/semaine', value: 29 },
        { title: '<1&nbsp;fois/semaine', value: 20 },
        { title: 'Jamais', value: 15 },
        {
          title:
            '<span class="grayedOut">Pas pris en compte (Moins de 15&nbsp;ans)</span>',
          value: 15,
          grayedOut: 15,
        },
      ],
    },
    {
      title: (
        <span>
          <span>
            Consommations de médicaments&nbsp;
            <img src={pill} className='icon' alt='Icon Pille' key='pill' />
          </span>
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Au moins 1&nbsp;médicament/semaine', value: 43 },
        { title: '<1&nbsp;médicament/semaine', value: 42 },
        {
          title:
            '<span class="grayedOut">Pas pris en compte (Moins de 15&nbsp;ans)</span>',
          value: 15,
          grayedOut: 15,
        },
      ],
    },
    {
      title: (
        <span>
          <span>
            Animaux domestiques&nbsp;
            <img src={dog} className='icon dog' alt='Icon Hund' key='dog' />
          </span>
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Avec animal domestique', value: 41 },
        { title: 'Sans animal domestique', value: 59 },
      ],
    },
    {
      title: (
        <span>
          <span>
            Locataires ou propriétaires&nbsp;
            <img
              src={house}
              className='icon house'
              alt='Icon Haus mit Garten'
              key='house'
            />
          </span>
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Locataires', value: 61 },
        { title: 'Propriétaires', value: 36 },
        { title: 'Autre situation', value: 3 },
      ],
    },
    {
      title: (
        <span>
          <span>
            Formation achevée la plus élevée&nbsp;
            <img
              src={student}
              className='icon student'
              alt='Icon Student'
              key='student'
            />
          </span>
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'École obligatoire', value: 13 },
        { title: 'Apprentissage', value: 23 },
        { title: 'Gymnase et école de culture générale', value: 7 },
        { title: 'Formation prof. supérieure', value: 13 },
        { title: 'Hautes écoles (Avec&nbsp;unis)', value: 17 },
        {
          title:
            '<span class="grayedOut">Pas pris en compte (Moins de 25&nbsp;ans)</span>',
          value: 27,
          grayedOut: 27,
        },
      ],
    },
    {
      title: (
        <span>
          <span>
            Situation professionnelle&nbsp;
            <img
              src={necktie}
              className='icon necktie'
              alt='Icon Hemd und Krawatte'
              key='necktie'
            />
          </span>
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Salarié·e·s', value: 48 },
        { title: 'Retraité·e·s', value: 19 },
        { title: 'Indépendant·e·s', value: 7 },
        { title: 'Sans emploi<br/>(en formation etc.)', value: 6 },
        { title: 'Chômage', value: 3 },
        { title: 'Hommes/femmes au foyer', value: 2 },
        {
          title:
            '<span class="grayedOut">Pas pris en compte (Moins de 15&nbsp;ans)</span>',
          value: 15,
          grayedOut: 15,
        },
      ],
    },
    {
      title: (
        <span>
          <span>
            Pendularité&nbsp;
            <b>
              <img src={car} className='icon car' alt='Icon Auto' key='car' />
              &nbsp;
              <img
                src={train}
                className='icon train'
                alt='Icon Zug'
                key='train'
              />
              &nbsp;
              <img
                src={bicycle}
                className='icon bicycle'
                alt='Icon Fahrrad'
                key='bicycle'
              />
            </b>
          </span>
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: 'Voiture', value: 24 },
        { title: 'Transports publics', value: 13 },
        { title: 'Vélo/vélo électrique', value: 4 },
        { title: 'À pied', value: 4 },
        { title: 'Moto', value: 1 },
        {
          title: 'Non-pendulaires<br />(Sans empl., télétravail, etc.)',
          value: 54,
        },
      ],
    },
    {
      title: (
        <span>
          <span>
            Durée du trajet domicile-travail&nbsp;
            <img
              src={clock}
              className='icon clock'
              alt='Icon Stoppuhr'
              key='clock'
            />
          </span>
        </span>
      ),
      text: (
        <>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
          nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
          rebum.
        </>
      ),
      categories: [
        { title: '0–15&nbsp;min.', value: 16 },
        { title: '16–30&nbsp;min.', value: 15 },
        { title: '31–45&nbsp;min.', value: 7 },
        { title: '46–60&nbsp;min.', value: 4 },
        { title: '>60&nbsp;min.', value: 4 },
        {
          title: 'Non-pendulaires<br />(Sans empl., télétravail, etc.)',
          value: 54,
        },
      ],
    },
  ],
}
